import { render, staticRenderFns } from "./tailored_navigation_onboarding_popover.vue.js?vue&type=template&id=ff4aa6d6&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tailored_navigation_onboarding_popover.vue?vue&type=template&id=ff4aa6d6&vue3"
import script from "./tailored_navigation_onboarding_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tailored_navigation_onboarding_popover.vue?vue&type=script&lang=js&vue3"
export * from "./tailored_navigation_onboarding_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tailored_navigation_onboarding_popover.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports